import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossYieldShekelFetch } from './actions';

export const sagasReportGrossYieldShekel = [
  takeLatest(actionReportGrossYieldShekelFetch.rejected, workerErrorNotifyThunk),
];
